module.exports = __webpack_public_path__ + "img/level_01_normal.9a40f1a9.svg";